export const numberValidation = (value: string): boolean => {
    return /^\d*$/.test(value);
}

export const alphabetValidation = (value: string): boolean => {
    return /^[a-zA-Z\s]*$/.test(value);
};

export const numberWithDecimalValidation = (value: string): boolean => {
    return /^(\d+(\.\d{0,2})?)?$/.test(value);
};